var _ellipse, _ellipse2, _line, _line2, _line3, _line4, _ellipse3, _circle, _circle2, _circle3, _circle4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _path15, _path16, _g, _path17, _g2, _path18, _ellipse4, _ellipse5, _g3, _rect3, _rect4, _path19, _ellipse6, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdNowStepOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 106,
    viewBox: "0 0 152 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.6205,
    cy: 71.1293,
    rx: 27,
    ry: 27,
    stroke: "#CAD0E1",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeDasharray: "1.5 2.25"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.5,
    cy: 55.8521,
    rx: 27,
    ry: 27,
    stroke: "#CAD0E1",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeDasharray: "1.5 2.25"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 137.513,
    y1: 83.2897,
    x2: 137.513,
    y2: 84.2406,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 137.513,
    y1: 85.0575,
    x2: 137.513,
    y2: 86.0084,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 136.187,
    y1: 84.6825,
    x2: 137.138,
    y2: 84.6825,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 137.955,
    y1: 84.6825,
    x2: 138.906,
    y2: 84.6825,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.5,
    cy: 68,
    rx: 11.5,
    ry: 11,
    stroke: "#CAD0E1",
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeDasharray: "1.5 2.25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6116,
    cy: 25.5667,
    r: 1.13839,
    stroke: "#CAD0E1",
    strokeWidth: 0.375
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3259,
    cy: 1.67794,
    r: 1.13839,
    stroke: "#CAD0E1",
    strokeWidth: 0.375
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.862,
    cy: 54.2944,
    r: 1.13839,
    stroke: "#CAD0E1",
    strokeWidth: 0.375
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4509,
    cy: 68.8029,
    r: 1.13839,
    stroke: "#CAD0E1",
    strokeWidth: 0.375
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 108.888,
    y1: 28.6646,
    x2: 108.888,
    y2: 29.6154,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 108.888,
    y1: 30.4325,
    x2: 108.888,
    y2: 31.3834,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 107.562,
    y1: 30.0575,
    x2: 108.513,
    y2: 30.0575,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 109.33,
    y1: 30.0575,
    x2: 110.281,
    y2: 30.0575,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 111.795,
    y1: 60.6696,
    x2: 111.795,
    y2: 61.6204,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 111.795,
    y1: 62.4374,
    x2: 111.795,
    y2: 63.3883,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 110.469,
    y1: 62.0624,
    x2: 111.42,
    y2: 62.0624,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 112.237,
    y1: 62.0624,
    x2: 113.187,
    y2: 62.0624,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.1275,
    y: 10.8715,
    width: 19.187,
    height: 10.5778,
    rx: 0.375,
    transform: "rotate(-26.3526 59.1275 10.8715)",
    stroke: "#CAD0E1",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0504 10.8541L80.6748 11.765C80.881 11.7845 81.0639 11.6332 81.0834 11.427C81.103 11.2208 80.9516 11.0379 80.7454 11.0184L71.4858 10.1419L71.0504 10.8541ZM69.0824 11.8289L68.2521 11.7438L63.3386 19.6412C63.2292 19.8171 63.2831 20.0483 63.4589 20.1577C63.6348 20.2671 63.866 20.2133 63.9754 20.0374L69.0824 11.8289Z",
    fill: "#CAD0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4333 11.2285L70.3734 11.877L76.4864 2.78089",
    stroke: "#CAD0E1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2828,
    y: 64.4936,
    width: 20.0761,
    height: 11.083,
    rx: 0.375,
    transform: "rotate(24.0179 96.2828 64.4936)",
    stroke: "#CAD0E1",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.267 74.0936L109.942 82.4372C110.059 82.6084 110.292 82.6528 110.463 82.5364C110.635 82.4199 110.679 82.1866 110.563 82.0154L105.094 73.9748L104.267 74.0936ZM102.143 73.1473L101.679 72.4534L92.0438 73.7633C91.8386 73.7912 91.6948 73.9802 91.7227 74.1854C91.7506 74.3906 91.9396 74.5344 92.1448 74.5065L102.143 73.1473Z",
    fill: "#CAD0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1399 65.0557L102.907 74.2894L114.298 73.147",
    stroke: "#CAD0E1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2073 34.6646C24.2073 53.2646 38.9573 67.7896 48.2073 72.7271V74.0396C23.0073 59.0396 31.7073 41.5396 39.2073 34.6646Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1448 33.5396C43.5198 31.7896 50.8698 27.6521 53.2698 25.1021C49.5823 25.2271 41.7948 27.0896 40.1448 33.5396Z",
    fill: "#CAD0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9573 40.2896C38.9573 40.6646 44.0073 40.3271 48.2073 35.9771C45.7424 35.1646 40.0415 34.8896 36.9573 40.2896Z",
    fill: "#CAD0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3323 51.1646C36.3323 50.4771 40.5198 47.8646 41.2698 42.9146C38.4573 42.9771 33.1323 44.7146 34.3323 51.1646Z",
    fill: "#CAD0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9573 60.9146C38.5198 60.1021 41.4573 57.0146 40.7073 51.1646C38.0198 51.8521 33.5073 54.7646 36.9573 60.9146Z",
    fill: "#CAD0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2073 69.7271C45.8948 67.7896 46.6698 63.0896 44.2698 59.7896C41.9573 60.9771 38.9073 64.6271 45.2073 69.7271Z",
    fill: "#CAD0E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2698 70.8521C39.8323 68.9771 35.3073 64.9271 28.7073 63.7271C30.1448 66.9146 34.6698 72.8021 41.2698 70.8521Z",
    fill: "#CAD0E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2073 60.9146C32.1448 58.2896 29.0073 52.7771 24.9573 51.7271C24.5267 54.7896 25.5738 60.9146 33.2073 60.9146Z",
    fill: "#CAD0E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5824 50.6021C30.7699 47.3521 30.3574 40.5521 27.2074 39.3521C25.4574 42.1021 23.6824 48.2021 30.5824 50.6021Z",
    fill: "#CAD0E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2073 39.3521C33.2073 39.3521 37.5199 35.0396 35.0824 28.1021C32.4574 30.5645 28.4073 36.262 33.2073 39.3521Z",
    fill: "#CAD0E1"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 107.339,
    y1: 31.7422,
    x2: 104.265,
    y2: 34.8506,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 110.339,
    y1: 63.6172,
    x2: 107.265,
    y2: 66.7256,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 32.7955,
    y1: 92.6021,
    x2: 34.9168,
    y2: 94.7234,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 36.773,
    y1: 96.5795,
    x2: 38.8943,
    y2: 98.7008,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 33.0606,
    y1: 98.7008,
    x2: 35.182,
    y2: 96.5795,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 37.0381,
    y1: 94.7234,
    x2: 39.1595,
    y2: 92.6021,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 106.963,
    y1: 33.2422,
    x2: 101.64,
    y2: 38.6012,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 109.963,
    y1: 65.1172,
    x2: 104.64,
    y2: 70.4762,
    stroke: "#CAD0E1",
    strokeWidth: 0.375,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.125 16.1021C102.125 16.1021 103.615 15.8616 104.25 15.227C104.885 14.5924 105.125 13.102 105.125 13.102C105.125 13.102 105.365 14.5924 106 15.227C106.635 15.8616 108.125 16.1021 108.125 16.1021C108.125 16.1021 106.635 16.3425 106 16.9771C105.365 17.6117 105.125 19.1021 105.125 19.1021C105.125 19.1021 104.885 17.6117 104.25 16.9771C103.615 16.3425 102.125 16.1021 102.125 16.1021Z",
    fill: "#CAD0E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 94.8521C54.5 94.8521 55.9904 94.6116 56.625 93.977C57.2597 93.3424 57.5001 91.852 57.5001 91.852C57.5001 91.852 57.7405 93.3424 58.3751 93.977C59.0097 94.6116 60.5001 94.8521 60.5001 94.8521C60.5001 94.8521 59.0097 95.0925 58.3751 95.7271C57.7405 96.3617 57.5001 97.8521 57.5001 97.8521C57.5001 97.8521 57.2597 96.3617 56.625 95.7271C55.9904 95.0925 54.5 94.8521 54.5 94.8521Z",
    fill: "#CAD0E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 28,
    width: 65,
    height: 55,
    rx: 6,
    fill: "#E2E5EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 29.5,
    width: 62,
    height: 52,
    rx: 4.5,
    stroke: "#818CB5",
    strokeWidth: 3
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0557 74.5575L60.0557 80C60.0557 80 59.9303 77.8746 60.0557 74.5575L60.0557 35C60.0557 33.3431 61.3989 32 63.0557 32L90 32C90 32 76.6465 33.3714 67.7441 46.4C61.7033 55.2408 60.3205 67.5548 60.0557 74.5575Z",
    fill: "#F6F7FA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 74.5H126.5V77.5C126.5 79.9853 124.485 82 122 82H54.5C52.0147 82 50 79.9853 50 77.5V74.5Z",
    fill: "#818CB5",
    stroke: "#818CB5",
    strokeWidth: 3
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 77.5C48.5 77.5 48.5 80.0161 56 80.5C63.5 80.9839 114.5 80.5 120.5 80.5C126.5 80.5 128 77.5 128 77.5C128 80.8137 125.314 83.5 122 83.5H54.5C51.1863 83.5 48.5 80.8137 48.5 77.5Z",
    fill: "#5E6B9B"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.5,
    cy: 36.25,
    rx: 6,
    ry: 2.25,
    fill: "#F6F7FA"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.75,
    cy: 35.5,
    rx: 2.25,
    ry: 1.5,
    fill: "#F6F7FA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 31.5,
    height: 57,
    rx: 3,
    fill: "#818CB5"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 31,
    width: 10.5,
    height: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37,
    width: 25.5,
    height: 45,
    fill: "#E2E5EE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0307 63.7139L15.0307 64.25C15.0307 64.25 14.9617 64.1946 15.0307 63.7139L15.0307 38.9999C15.0307 38.4477 15.4784 37.9999 16.0307 37.9999L31.5 37.9999C31.5 37.9999 24.1555 39.2857 19.2593 51.5C15.9368 59.7882 15.1763 62.699 15.0307 63.7139Z",
    fill: "#F6F7FA"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 40.5,
    rx: 3,
    ry: 1.5,
    fill: "#F6F7FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.5 77.5C25.1 77.5 14.25 69.5 11 65.5V82C11 83.6569 12.3431 85 14 85H39.5C41.1569 85 42.5 83.6569 42.5 82V77.5Z",
    fill: "#5E6B9B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2044_1280",
    x: 50,
    y: 28,
    width: 77,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.615686 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2044_1280",
    x: 42.5,
    y: 73,
    width: 91.5,
    height: 31.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.615686 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2044_1280",
    x: 5,
    y: 28,
    width: 43.5,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.94902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdNowStepOne);
export default __webpack_public_path__ + "static/media/id-now-step-one.05a60afc9d7d8c8351741b96882948cd.svg";
export { ForwardRef as ReactComponent };